"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSSN = exports.validateOrgNumber = exports.validateRegistrationNumber = exports.validateEmail = exports.validateZipCode = exports.validatePhonenumber = exports.validatePositiveNumber = exports.validateNumber = exports.validateString = exports.fetchValidation = exports.validate = void 0;
const enums_1 = require("../../enums");
const constants_1 = require("../../constants");
// @ts-ignore
const fnrvalidator_1 = __importDefault(require("@navikt/fnrvalidator"));
const validate = (validationObject) => {
    const validator = (0, exports.fetchValidation)(validationObject);
    return validator(validationObject.value);
};
exports.validate = validate;
const fetchValidation = (validationObject) => {
    switch (validationObject.type) {
        case enums_1.VALIDATION_TYPE.STRING:
            return exports.validateString;
        case enums_1.VALIDATION_TYPE.PHONENUMBER:
            return exports.validatePhonenumber;
        case enums_1.VALIDATION_TYPE.ZIPCODE:
            return exports.validateZipCode;
        case enums_1.VALIDATION_TYPE.EMAIL:
            return exports.validateEmail;
        case enums_1.VALIDATION_TYPE.NUMBER:
            return exports.validateNumber;
        case enums_1.VALIDATION_TYPE.NUMBERPOSITIVE:
            return exports.validatePositiveNumber;
        case enums_1.VALIDATION_TYPE.REGISTRATIONNUMBER:
            return exports.validateRegistrationNumber;
        case enums_1.VALIDATION_TYPE.ORG_NR:
            return exports.validateOrgNumber;
        default:
            return () => false;
    }
};
exports.fetchValidation = fetchValidation;
const validateString = (value) => {
    return !!value && value.length > 0;
};
exports.validateString = validateString;
const validateNumber = (value) => {
    return !!value;
};
exports.validateNumber = validateNumber;
const validatePositiveNumber = (value) => {
    return !!value && value > 0;
};
exports.validatePositiveNumber = validatePositiveNumber;
const validatePhonenumber = (value) => {
    return !!value && constants_1.phoneRegex.test(value);
};
exports.validatePhonenumber = validatePhonenumber;
const validateZipCode = (value) => {
    return !!value && value.length === 4;
};
exports.validateZipCode = validateZipCode;
const validateEmail = (value) => {
    return !!value && constants_1.emailRegex.test(value);
};
exports.validateEmail = validateEmail;
const validateRegistrationNumber = (value) => {
    return !!value && constants_1.regNrRegex.test(value);
};
exports.validateRegistrationNumber = validateRegistrationNumber;
const validateOrgNumber = (value) => {
    return !!value && constants_1.orgNrRegex.test(value);
};
exports.validateOrgNumber = validateOrgNumber;
const validateSSN = (value) => {
    const isNumber = typeof value === 'number';
    if (typeof value !== 'string' && !isNumber) {
        return false;
    }
    const validation = fnrvalidator_1.default.fnr(isNumber ? value.toString() : value);
    return !!value && validation.status === 'valid';
};
exports.validateSSN = validateSSN;
//# sourceMappingURL=validation.js.map